var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.271,
    height: 35,
    viewBox: "0 0 34.271 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#cef8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edfff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f78fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ac5fd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2950",
    "data-name": "Group 2950",
    transform: "translate(0.209 0.326)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 17.135,
    cy: 17.5,
    rx: 17.135,
    ry: 17.5,
    transform: "translate(-0.209 -0.326)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(-0.209 -0.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4151",
    "data-name": "Group 4151"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 17.135,
    cy: 17.5,
    rx: 17.135,
    ry: 17.5,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4153",
    "data-name": "Group 4153",
    transform: "translate(6 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4152",
    "data-name": "Group 4152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3009",
    "data-name": "Path 3009",
    d: "M32.046,19.595a.631.631,0,0,0-.631-.631H16.278a.631.631,0,0,0,0,1.263H18.17v10.1h1.892a1.9,1.9,0,0,1,1.892,1.894v1.894h3.784V32.223a1.9,1.9,0,0,1,1.892-1.894h1.892v-10.1h1.892A.631.631,0,0,0,32.046,19.595Zm-8.2,9.471A3.157,3.157,0,1,1,27,25.909a3.159,3.159,0,0,1-3.153,3.157Zm0-5.051a1.894,1.894,0,1,0,1.892,1.894A1.9,1.9,0,0,0,23.847,24.015Zm-3.784,7.577H18.17v1.894a.631.631,0,0,0,.631.631h1.892V32.223A.632.632,0,0,0,20.063,31.592ZM27,32.223v1.894h1.892a.631.631,0,0,0,.631-.631V31.592H27.631A.632.632,0,0,0,27,32.223Zm6.938-15.786H13.756a.631.631,0,0,0-.631.631V22.12a.631.631,0,0,0,.631.631h3.153V21.489h-.631a1.894,1.894,0,0,1,0-3.789H31.415a1.894,1.894,0,0,1,0,3.789h-.631v1.263h3.153a.631.631,0,0,0,.631-.631V17.069A.631.631,0,0,0,33.938,16.437Z",
    transform: "translate(-13.125 -16.437)",
    fill: "url(#linear-gradient-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.f0d0145aae5a63e23395d79df77b1de9.svg";
export { ForwardRef as ReactComponent };